var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowInMyTasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3626 7.36366C14.5653 7.64766 14.6666 7.79032 14.6666 8.00032C14.6666 8.21099 14.5653 8.35299 14.3626 8.63699C13.4519 9.91432 11.1259 12.667 7.99992 12.667C4.87325 12.667 2.54792 9.91366 1.63725 8.63699C1.43459 8.35299 1.33325 8.21032 1.33325 8.00032C1.33325 7.78966 1.43459 7.64766 1.63725 7.36366C2.54792 6.08632 4.87392 3.33366 7.99992 3.33366C11.1266 3.33366 13.4519 6.08699 14.3626 7.36366Z",
    stroke: "#269ACF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.00032C10 7.46989 9.78929 6.96118 9.41421 6.58611C9.03914 6.21103 8.53043 6.00032 8 6.00032C7.46957 6.00032 6.96086 6.21103 6.58579 6.58611C6.21071 6.96118 6 7.46989 6 8.00032C6 8.53075 6.21071 9.03946 6.58579 9.41453C6.96086 9.78961 7.46957 10.0003 8 10.0003C8.53043 10.0003 9.03914 9.78961 9.41421 9.41453C9.78929 9.03946 10 8.53075 10 8.00032Z",
    stroke: "#269ACF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowInMyTasksIcon);
export default __webpack_public_path__ + "static/media/show_in_my_tasks_icon.55cb99c071edc16617c7098f7b1995bc.svg";
export { ForwardRef as ReactComponent };